module.exports = __webpack_public_path__ + "img/la.888b3363.png";